import React, {ChangeEvent, useState, useEffect} from 'react';
import {DarkStoreType} from "../../../common/types";
import {Card, Input} from "antd";
import styles from './darkStoereList.module.sass'

type DarkStoreListPropsType = {
    data: DarkStoreType[];
};

export const DarkStoreList = ({data}: DarkStoreListPropsType) => {
    const [filter, setFilter] = useState('');
    const [current, setCurrent] = useState<DarkStoreType | null>(null);

    // Фильтрация данных
    const filteredData = data.filter((el) => el.darkstora_y_lavka.includes(filter));

    // Эффект для автоматического выбора элемента, но не сбрасывает выбранный вручную
    useEffect(() => {
        if (filteredData.length > 0) {
            // Если текущий элемент есть в отфильтрованном списке, оставляем его
            if (!current || !filteredData.some(el => el.id === current.id)) {
                setCurrent(filteredData[0]);
            }
        } else {
            setCurrent(null);
        }
    }, [filteredData]);

    // Обработчик клика по элементу списка
    const onClickHandler = (el: DarkStoreType) => {
        setCurrent(el); // Устанавливаем выбранный элемент вручную
    };

    // Обработчик изменения значения в поле поиска
    const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value);
    };

    const tableNames = {
        darkstora_y_lavka: "Адрес",
        city: "Город",
        bolshaya_lavka: "Большая лавка",
        otkuda_dostavka_bolshoy_lavki: "Адрес большой лавки",
        otkuda_dostavka: "Адрес доставки",
        status_size: "Размер",
        status_aktivnost: "Статус",
        rezhim_raboty: "Режим работы",
        kol_vo_tovarov: "Количестро товаров",
        kol_vo_tovarov_iz_apteki: "Количество товаров из аптеки",

    }

    const content = Object.keys(tableNames).map((el) => {
    const key = el as keyof typeof tableNames; // Указываем, что el — ключ tableNames
    return (
        <tr key={key} style={{height: 40}}>
            <td style={{ width: '40%', overflow: "hidden", fontWeight: 'bold' }}>{tableNames[key]}</td>
            <td style={{ width: '60%', overflow: "hidden" }}>{current?.[key] ?? '—'}</td>
        </tr>
    );
});

    return (
        <Card className={styles.card}>
            <Input
                placeholder="Введите для поиска"
                allowClear
                onChange={onSearch}
                style={{width: 400, marginBottom: 10}}
            />
            <div className={styles.block}>
                <div className={styles.list}>
                    {filteredData.map((el) => (
                        <div
                            key={el.id}
                            onClick={() => onClickHandler(el)}
                            style={{
                                cursor: 'pointer',
                                color: 'white',
                                backgroundColor: current?.id === el.id ? '#08A652' : 'transparent',
                                padding: '5px',
                                margin: '2px 0',
                            }}
                        >
                            {el.darkstora_y_lavka}
                        </div>
                    ))}
                </div>
                <div className={styles.content}>
                    <table>
                        <tbody>
                            {content}
                        </tbody>
                    </table>
                </div>
            </div>

        </Card>
    );
};


